<template>
  <div class="cus-level" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" >
      <el-form-item label="物流方案编码" prop="segmentLineCode">
        <el-input v-model="form.segmentLineCode" placeholder="请输入编码"></el-input>
      </el-form-item>
      <el-form-item label="物流方案名称" prop="segmentLineName">
        <el-input v-model="form.segmentLineName" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="运输方式" prop="transportMode">
        <el-select v-model="form.transportMode" placeholder="请选择运输方式">
          <el-option
            v-for="item in transportArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="isEnabled">
        <el-select v-model="form.isEnabled" placeholder="请选择">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="发货地行政区" prop="beginAddressName">
        <el-cascader
          :options="cityOptions"
          v-model="form.beginAddressName"
          :props="cascaderProps"
          clearable
        />
      </el-form-item>

      <el-form-item label="收货地行政区" prop="endAddressName">
        <el-cascader
          :options="cityOptions"
          v-model="form.endAddressName"
          :props="cascaderProps"
          clearable
        />
      </el-form-item>
      <el-form-item label="发货地" prop="manageBeginAddress">
        <el-input v-model="form.manageBeginAddress" placeholder="请输入发货地"></el-input>
      </el-form-item>
      <el-form-item label="收货地" prop="manageEndAddress">
        <el-input v-model="form.manageEndAddress" placeholder="请输入收货地"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <com-table :list="list" :columns="columns" :type="'list'" @look="handleLook" @historyVersion="handleHistoryVersion"/>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <history-version-dialog :show.sync="dialogVisible" :info="dialogInfo" :source="'logistics'"></history-version-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HistoryVersionDialog from '../components/historyVersionDialog'
import ComTable from '../components/comTable'
import logisticsVal from '../logisticsVal'
const RenderCell = {
  functional: true,
  props: ['render', 'row', 'index'],
  render: (h, ctx) => {
    return ctx.props.render(h, ctx.props.row, ctx.props.index)
  }
}
export default {
  name: 'logisticsSolution',
  components: { HistoryVersionDialog, RenderCell, ComTable },
  data () {
    return {
      form: {
        segmentLineName: '',
        segmentLineCode: '',
        transportMode: '',
        isEnabled: '',
        beginAddressName: [],
        endAddressName: [],
        manageBeginAddress: '',
        manageEndAddress: ''
      },
      dialogVisible: false,
      dialogInfo: {},
      transportArr: [
        ...Object.keys(logisticsVal.transportArr).map(key => ({
          label: logisticsVal.transportArr[key],
          value: -Number(key)
        })),
        ...Object.keys(logisticsVal.transportArr1).map(key => ({
          label: logisticsVal.transportArr1[key],
          value: Number(key)
        }))
      ],
      statusList: Object.keys(logisticsVal.statusArr).map(key => ({
        label: logisticsVal.statusArr[key],
        value: Number(key)
      })),
      cityOptions: [],
      cascaderProps: {
        value: 'name',
        label: 'name',
        children: 'children',
        emitPath: true
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getLogisticsSolutionList', listState: 'getLogisticsSolutionState', columns: 'getLogisticsColumns' })
  },
  methods: {
    ...mapActions(['getLogisticsSolutionList', 'getCityInfo', 'getArea']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      if (params.beginAddressName && params.beginAddressName.length) {
        params.beginAddressName = params.beginAddressName.join('')
      } else {
        params.beginAddressName = ''
      }

      if (params.endAddressName && params.endAddressName.length) {
        params.endAddressName = params.endAddressName.join('')
      } else {
        params.endAddressName = ''
      }
      this.getLogisticsSolutionList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getLogisticsSolutionList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.getLogisticsSolutionList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 查看
    handleLook (row) {
      this.$router.push({ name: 'logisticsDetail', query: { id: row.id } })
    },
    // 历史版本
    handleHistoryVersion (row) {
      this.dialogInfo = row
      this.dialogVisible = true
    },
    initCitis () {
      this.getCityInfo().then(res => {
        this.cityOptions = this.formatAreaData(res)
      })
    },
    formatAreaData (arr) {
      return arr.map(item => ({
        name: item.name,
        children: item.children ? this.formatAreaData(item.children) : null
      }))
    }
  },
  mounted () {
    this.handleSearch()
    this.initCitis()
  }
}
</script>

<style scoped>
</style>
